<template>
  <div>
    <el-card>
      <el-row class="title-biaoti">白名单管理</el-row>
      <el-row class="search">
        <el-input type="number" v-model="search.rid" placeholder="请输入rid" clearable style="width: 300px"></el-input>
        <el-select v-model="search.whiteType" placeholder="请选择">
          <el-option v-for="item in configList" :key="item.value" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="search.channel" placeholder="请选择渠道">
          <el-option v-for="item in channelList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <el-button type="primary" @click="query(true)" :loading="loading"> 查询 </el-button>
        <el-button type="warning" @click="operate(1)"> 添加用户 </el-button>
        <el-button type="success" @click="operate(4)"> 添加设备 </el-button>
        <el-upload class="upload-demo" :limit="1" action :on-change="addExcel" ref="upload">
          <el-button type="danger">批量上传</el-button>
        </el-upload>
      </el-row>
      <el-row>
        <el-table :data="dataList" style="width: 100%" stripe border v-loading="loading">
          <el-table-column prop="rid" label="rid" align="center"> </el-table-column>
          <el-table-column prop="uid" label="uid" align="center"> </el-table-column>
          <el-table-column prop="name" label="名字" align="center"> </el-table-column>
          <el-table-column prop="channel" label="渠道" align="center"> </el-table-column>
          <el-table-column prop="whiteType" label="白名单类型" align="center">
            <template slot-scope="scope">
              {{ configList.find((item) => item.value === scope.row.whiteType).name }}
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="operate(3, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-pagination @current-change="handleCurrent" :current-page.sync="pageInfo.page" :page-size="pageInfo.pageSize"
          layout="total,prev, pager, next, jumper" :page-count="pageInfo.total">
        </el-pagination>
      </el-row>
    </el-card>
    <el-dialog title="新增" :visible.sync="dialog" :before-close="cancel" width="500px">
      <div class="item" v-if="!inputDeviceId">
        <span class="item_label">用户rid：</span>
        <el-input v-model="ridListStr" type="text" />
      </div>
      <div class="item" v-else>
        <span class="item_label">设备ID:</span>
        <el-input v-model="deviceId" type="text" />
      </div>
      <div style="height: 10px;"></div>
      <div class="item">
        <span class="item_label">白名单类型：</span>
        <el-select v-model="addWhiteType" placeholder="请选择">
          <el-option v-for="item in configList" :key="item.value" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="operate(2)">新 增</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: {
        rid: null,
        whiteType: 1,
        channel: ''
      },
      pageInfo: {
        page: 1,
        total: 0,
        pageSize: 20,
      },
      loading: false,
      upload: false,
      dialog: false,
      dataList: [],
      ridListStr: "",
      addWhiteType: 1,
      configList: [],
      channelList: [],
      inputDeviceId: false,
      deviceId: ''
    };
  },
  methods: {
    // 获取渠道列表
    async getAppList() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.channelList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )
      if (res.code == 0) {
        this.channelList = res.data
        this.channelList.unshift({ label: 'ALL', value: '' })
      }
    },
    callback() { },
    async query(bool) {
      if(bool) this.pageInfo.page = 1
      this.loading = true;
      const { data: res } = await this.$axios({
        method: "get",
        url:
          this.$store.getters.path.white_query +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          ...this.search,
          ...this.pageInfo,
        },
      });
      this.loading = false;
      if (res.code != 0) return this.$message(res.msg);
      console.log(res.data.whiteList);
      this.dataList = res.data.whiteList;
      this.pageInfo.total = res.data.totalPage;
    },
    async addExcel(file) {
      if (this.upload) return;
      this.upload = true;
      const formdata = new FormData();
      formdata.append("whiteListFile", file.raw);
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.white_batchAdd +
        "?username=" +
        this.$store.getters.username +
        "&token=" +
        this.$store.getters.token,
        formdata
      );
      this.upload = false;
      this.$refs.upload.clearFiles();
      if (res.code != 0) return this.$message(res.msg);
      this.query();
    },
    async operate(type, row) {
      if (type == 1) {
        this.dialog = true;
      } else if (type == 2) {
        const params = {
          whiteType: this.addWhiteType,
        }
        if (this.inputDeviceId) {
          params.deviceId = this.deviceId
        } else {
          params.rid = Number(this.ridListStr)
        }

        const { data: res } = await this.$axios(
          this.$store.getters.path.white_add +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
          {
            params,
          }
        );
        if (res.code != 0) return this.$message(res.msg);
        this.$message.success('新增成功')
        this.query();
        this.cancel();
      } else if (type == 3) {
        this.$confirm("确认删除此项白名单配置", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const { data: res } = await this.$axios(
            this.$store.getters.path.white_del +
            "?username=" +
            this.$store.getters.username +
            "&token=" +
            this.$store.getters.token,
            {
              params: {
                rid: Number(row.rid),
                whiteType: row.whiteType,
                deviceId: row.uid
              },
            }
          );
          if (res.code !== 0) return this.$message.error("删除失败");
          this.$message.success("删除成功");
          this.query();
        });
      } else if (type == 4) {
        this.dialog = true;
        this.inputDeviceId = true
      }
    },
    handleCurrent(newpage) {
      this.page = newpage;
      this.query();
    },
    async queryConfig() {
      const { data: res } = await this.$axios({
        method: "get",
        url:
          this.$store.getters.path.white_config_query +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        withCredentials: true,
      });
      if (res.code === 0) {
        this.configList = res.data;
      }
    },
    cancel() {
      this.dialog = false;
      this.ridListStr = "";
    },
  },
  created() {
    this.getAppList();
    this.query();
    this.queryConfig();
  },
};
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;

  >* {
    margin: 2px 6px;
  }
}

.item_label {
  width: 140px;
  text-align: left;
  margin-right: 10px;
  box-sizing: content-box;
}

.item {
  display: grid;
  grid-template-columns: 80px 1fr;
  align-items: center;
}
</style>
